<template>
    <div class="detail">
        <div class="top-content main_content">
            <TopMenus v-model="activeIndex"></TopMenus>
        </div>
        <div class="banner-box">
            <div class="main_content banner-content">
                <div class="banner">
                    <el-carousel indicator-position="outside" arrow="always" height="338rem">
                        <el-carousel-item class="carousel-item">
                            <img src="./images/218M带纸顶.232.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/218M带纸顶.241.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/218M带纸顶.242.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/218M带纸顶.244.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/218M带纸顶.245.png" alt="img"/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="info">
                    <div class="title"><span class="other-color">KM-218M</span>系列面单打印机</div>
                    <div class="sub-title">电脑连接，支持多规格标签和面单打印</div>
                    <div class="text">
                        通讯接口：usb<br/>
                        打印速度：150mm/S<br/>
                        打印宽度：max80mm<br/>
                        适用：电商、快递物流等面单打印
                    </div>
                </div>
            </div>
        </div>
        <template v-if="activeIndex===0">
            <div class="main_content content-bg">
                <img src="./images/km_02.jpeg" alt="bg">
                <img src="./images/km_05.jpeg" alt="bg">
                <img src="./images/km_08.jpeg" alt="bg">
                <img src="./images/km_11.jpeg" alt="bg">
                <img src="./images/km_14.jpeg" alt="bg">
                <img src="./images/km_17.jpeg" alt="bg">
                <img src="./images/km_20.jpeg" alt="bg">
                <img src="./images/km_23.jpeg" alt="bg">
                <img src="./images/km_29.jpeg" alt="bg">
                <img src="./images/km_32.jpeg" alt="bg">
            </div>
        </template>
        <div v-else-if="activeIndex===1" class="content-bg-cs"></div>
    </div>
</template>

<script>
import TopMenus from '@/views/printCenter/TopMenus.vue'

export default {
    name: "deviceDetail",
    components: {TopMenus},
    data() {
        return {
            activeIndex: 0
        };
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../printCenter.scss";

.detail {
    .content-bg {
        img {
            width: 100%;
        }
    }

    .content-bg-cs {
    }
}
</style>
